import connect from 'react-redux/es/connect/connect';
import {bindActionToPromise} from '../../../../../../utils/redux-form';
import {getGame, saveGame} from './modules/game-edit-actions';
import React, {Component} from 'react';
import DocumentTitle from '../../../../../../components/document-title';
import Loading from '../../../../../../components/loading';
import GameForm from '../../../../../../components/form/game-form';
import {openGamesList} from '../../../../../../actions/flow-actions';
import SweetAlert from '../../../../../../components/sweet-alert';

class EditContainer extends Component {
    state = {
        showAlert: false,
    };

    componentWillMount() {
        const {params} = this.props.match;
        this.props.dispatch(getGame(params.id));
    }

    onSubmitSuccess = () => {
        this.setState({showAlert: true});
    };

    hideSaveAlert = () => {
        this.props.dispatch(openGamesList());
        this.setState({showAlert: false});

    };

    render() {
        const {loading, game} = this.props;
        return (<DocumentTitle title="Redaguoti rungtynes">
            <div>
                {this.state.showAlert ? <SweetAlert success={true} title="Rungtynės atnaujintos"
                                                    onConfirm={this.hideSaveAlert}/> : null}


                {loading || !game ? <Loading/> :
                    <GameForm onSubmit={this.props.actions.onSubmit} initialValues={game}
                              onSubmitSuccess={this.onSubmitSuccess} leagues={this.props.leagues}/>}</div>
        </DocumentTitle>);
    }
}

export default connect((state) => {
    return {
        game: state.app.games.edit.game.item,
        leagues: state.user.currentUser ? state.user.currentUser.leagues: [],
        loading: state.app.games.edit.game.loading,
    };
}, (dispatch) => {
    return {
        actions: {
            onSubmit: bindActionToPromise(dispatch, saveGame),
        },
        dispatch
    };
})(EditContainer);



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/edit/game-edit-container.jsx